/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DomesticV2BookingsBookingIdSharePost200Response } from '../models';
// @ts-ignore
import { DomesticV2BookingsBookingIdSharePost200Response1 } from '../models';
// @ts-ignore
import { DomesticV2BookingsBookingIdSharePost422Response } from '../models';
// @ts-ignore
import { DomesticV2BookingsBookingIdSharePostRequest } from '../models';
// @ts-ignore
import { DomesticV2BookingsBookingIdSharePostRequest1 } from '../models';
/**
 * ShareBookingsApi - axios parameter creator
 * @export
 */
export const ShareBookingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Share a booking with guests
         * @param {string} bookingId 
         * @param {DomesticV2BookingsBookingIdSharePostRequest1} body Invite information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdSharePost: async (bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdSharePost', 'bookingId', bookingId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdSharePost', 'body', body)
            const localVarPath = `/domestic/v2/bookings/{booking_id}/share`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept a booking invite
         * @param {string} bookingId 
         * @param {DomesticV2BookingsBookingIdSharePostRequest} body Invite information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdSharePut: async (bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdSharePut', 'bookingId', bookingId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdSharePut', 'body', body)
            const localVarPath = `/domestic/v2/bookings/{booking_id}/share`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShareBookingsApi - functional programming interface
 * @export
 */
export const ShareBookingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShareBookingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Share a booking with guests
         * @param {string} bookingId 
         * @param {DomesticV2BookingsBookingIdSharePostRequest1} body Invite information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsBookingIdSharePost(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV2BookingsBookingIdSharePost200Response1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsBookingIdSharePost(bookingId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accept a booking invite
         * @param {string} bookingId 
         * @param {DomesticV2BookingsBookingIdSharePostRequest} body Invite information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsBookingIdSharePut(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV2BookingsBookingIdSharePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsBookingIdSharePut(bookingId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShareBookingsApi - factory interface
 * @export
 */
export const ShareBookingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShareBookingsApiFp(configuration)
    return {
        /**
         * Share a booking with guests
         * @param {string} bookingId 
         * @param {DomesticV2BookingsBookingIdSharePostRequest1} body Invite information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdSharePost(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest1, options?: any): AxiosPromise<DomesticV2BookingsBookingIdSharePost200Response1> {
            return localVarFp.domesticV2BookingsBookingIdSharePost(bookingId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept a booking invite
         * @param {string} bookingId 
         * @param {DomesticV2BookingsBookingIdSharePostRequest} body Invite information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdSharePut(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest, options?: any): AxiosPromise<DomesticV2BookingsBookingIdSharePost200Response> {
            return localVarFp.domesticV2BookingsBookingIdSharePut(bookingId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShareBookingsApi - interface
 * @export
 * @interface ShareBookingsApi
 */
export interface ShareBookingsApiInterface {
    /**
     * Share a booking with guests
     * @param {string} bookingId 
     * @param {DomesticV2BookingsBookingIdSharePostRequest1} body Invite information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareBookingsApiInterface
     */
    domesticV2BookingsBookingIdSharePost(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest1, options?: AxiosRequestConfig): AxiosPromise<DomesticV2BookingsBookingIdSharePost200Response1>;

    /**
     * Accept a booking invite
     * @param {string} bookingId 
     * @param {DomesticV2BookingsBookingIdSharePostRequest} body Invite information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareBookingsApiInterface
     */
    domesticV2BookingsBookingIdSharePut(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest, options?: AxiosRequestConfig): AxiosPromise<DomesticV2BookingsBookingIdSharePost200Response>;

}

/**
 * ShareBookingsApi - object-oriented interface
 * @export
 * @class ShareBookingsApi
 * @extends {BaseAPI}
 */
export class ShareBookingsApi extends BaseAPI implements ShareBookingsApiInterface {
    /**
     * Share a booking with guests
     * @param {string} bookingId 
     * @param {DomesticV2BookingsBookingIdSharePostRequest1} body Invite information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareBookingsApi
     */
    public domesticV2BookingsBookingIdSharePost(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest1, options?: AxiosRequestConfig) {
        return ShareBookingsApiFp(this.configuration).domesticV2BookingsBookingIdSharePost(bookingId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept a booking invite
     * @param {string} bookingId 
     * @param {DomesticV2BookingsBookingIdSharePostRequest} body Invite information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareBookingsApi
     */
    public domesticV2BookingsBookingIdSharePut(bookingId: string, body: DomesticV2BookingsBookingIdSharePostRequest, options?: AxiosRequestConfig) {
        return ShareBookingsApiFp(this.configuration).domesticV2BookingsBookingIdSharePut(bookingId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
